/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/184-power-cord': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 4.414L14.586 3l-2.793 2.793-1.586-1.586L13 1.414 11.586 0 8.793 2.793 7 1 5.646 2.353l8 8L15 9l-1.793-1.793L16 4.414zM12.407 10.528L5.472 3.593C3.975 5.388 2.276 8.163 3.45 10.55l-2.066 2.066a1.254 1.254 0 000 1.768l.232.232a1.254 1.254 0 001.768 0L5.45 12.55c2.387 1.174 5.161-.524 6.957-2.022z"/>'
  }
})
